import apiUrls from '@mgCommon/constants/api-urls';
import createHttpClient from '@mgCommon/http/httpClient';
import type { UserInfo } from '@mgCommon/types';
import { getCbBaseURL, getCbVarible, prepareUrl } from '@mgCommon/utils/utils';
import type { ITokens } from '@opap/jbca-postmonger-react/lib/interfaces/tokens';
import to from 'await-to-js';

const httpClient = createHttpClient({
  baseURL: getCbBaseURL(),
  authToken: getCbVarible(),
});

export async function getMcUserInfo(tokens: ITokens) {
  const url = prepareUrl(apiUrls.USER_INFO, {
    variable: '{fuel}',
    value: tokens.fuel2token,
  });

  const [err, resp] = await to(httpClient.get<{ result: UserInfo }>(url));

  if (err || !resp?.data) {
    console.error('Error fetching user info:', err?.message);
    throw new Error('Error fetching user info');
  }

  return resp.data.result;
}
